import React from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../../../../../../../components/Icon';

import { StatusValues, TMSStepTypes } from '../enums';

import { STATUS } from '../../../../NFFilters/enums';

import { LinkText, LinkWrapper } from '../styles';

const RenderBottom = (
  stepType,
  statusType,
  stepInvoice,
  hasPosition,
  finishedDate,
  id,
  isAgroDivision,
) => {
  if (isAgroDivision || (hasPosition && finishedDate) || (!hasPosition && finishedDate)) {
    return null;
  } else if (
    (stepType === TMSStepTypes.CARRIER &&
      statusType === StatusValues.NOT_STARTED) ||
    (stepType === TMSStepTypes.CARRIER &&
      statusType === StatusValues.ON_HOLD) ||
    (stepType === TMSStepTypes.DELIVERY &&
      statusType === StatusValues.ON_HOLD) ||
    (stepType === TMSStepTypes.DELIVERY &&
      statusType === StatusValues.NOT_STARTED)
  ) {
    return null;
  } else if (
    hasPosition && stepType === TMSStepTypes.CARRIER &&
      statusType === StatusValues.IN_PROGRESS
  ) {
    return (
      <NavLink
        to={`/u/dashboard/tempo-real/${id}`}
        style={{ textDecoration: 'none' }}
      >
        <LinkWrapper>
          <LinkText>Ver no mapa</LinkText>
          <Icon name="open_in_new" />
        </LinkWrapper>
      </NavLink>
    );
  } else if (
    (!hasPosition && stepInvoice === 0 && stepType === TMSStepTypes.CARRIER) ||
    (!hasPosition &&
      stepInvoice === STATUS.SEPARATION &&
      stepType === TMSStepTypes.CARRIER) ||
    (!hasPosition &&
      stepInvoice === STATUS.COLLECT &&
      stepType === TMSStepTypes.CARRIER) ||
    (!hasPosition &&
      stepInvoice === STATUS.INTERCHANGE &&
      stepType === TMSStepTypes.CARRIER) ||
    (!hasPosition &&
      stepInvoice === STATUS.SHIPMENT &&
      stepType === TMSStepTypes.CARRIER) ||
    (!hasPosition &&
      stepInvoice === STATUS.DELIVERED &&
      stepType === TMSStepTypes.CARRIER) ||
    (!hasPosition &&
      stepInvoice === STATUS.REFUSED_DELIVERED &&
      stepType === TMSStepTypes.CARRIER) ||
    (!hasPosition &&
      stepInvoice === STATUS.CANCELED &&
      stepType === TMSStepTypes.CARRIER) ||
    (hasPosition && stepInvoice === 0 && stepType === TMSStepTypes.CARRIER) ||
    (hasPosition &&
      stepInvoice === STATUS.SEPARATION &&
      stepType === TMSStepTypes.CARRIER) ||
    (hasPosition &&
      stepInvoice === STATUS.COLLECT &&
      stepType === TMSStepTypes.CARRIER) ||
    (hasPosition &&
      stepInvoice === STATUS.INTERCHANGE &&
      stepType === TMSStepTypes.CARRIER) ||
    (hasPosition &&
      stepInvoice === STATUS.SHIPMENT &&
      stepType === TMSStepTypes.CARRIER) ||
    (hasPosition &&
      stepInvoice === STATUS.DELIVERED &&
      stepType === TMSStepTypes.CARRIER) ||
    (hasPosition &&
      stepInvoice === STATUS.REFUSED_DELIVERED &&
      stepType === TMSStepTypes.CARRIER) ||
    (hasPosition &&
      stepInvoice === STATUS.CANCELED &&
      stepType === TMSStepTypes.CARRIER) ||
    (!hasPosition &&
      stepInvoice === STATUS.TRANSFER &&
      stepType === TMSStepTypes.CARRIER) ||
    (!hasPosition &&
      stepInvoice === STATUS.CARRIER_IN_ROUTE &&
      stepType === TMSStepTypes.CARRIER)
  ) {
    return (
      <LinkWrapper desabledPin>
        <LinkText desabledPin>Posição indisponível</LinkText>
        <Icon name="location_off" />
      </LinkWrapper>
    );
  }
  return null;
};

export default RenderBottom;
